import EmailAIDetails from "@/domain/entities/emails/EmailAIDetails";
import CategoryTag from "@/domain/enums/CategoryTag";
import { MailAIDetails } from "@cs_teamwaydev/mailvista-sdk_react";
import todoMapper from "../todoMapper";
import emailEntityMapper from "./emailEntityMapper";

const aiDetailsMapper = (
    aiDetails: MailAIDetails,
    internetMessageId: string,
): EmailAIDetails =>
    new EmailAIDetails({
        analyzedMailDate: new Date(aiDetails.analyzedMailDate || new Date()),
        mailSummary: aiDetails.mailSummary,
        longMailSummary: aiDetails.longMailSummary,
        categories: aiDetails.categories.filter((category) =>
            Object.values(CategoryTag).includes(category as CategoryTag),
        ) as CategoryTag[],
        entities: aiDetails.entities.map(emailEntityMapper),
        keywords: aiDetails.keywords,
        toDo: aiDetails.toDo.map((todo) => todoMapper(todo, internetMessageId)),
    });

export default aiDetailsMapper;
